import { observer } from 'mobx-react-lite'
import Announcement from './Announcement'
import { AnnouncementEnum, AnnouncementTypeEnum } from '@gap/backend/app-services/announcement/enums/AnnouncementEnums'
import { useAnnouncementStore } from './AnnouncementStore'

export type AnnouncementContent = {
   content: React.ReactNode
   type: AnnouncementTypeEnum
   dismissible?: boolean
}

export default observer(function Announcements() {
   const announcementStore = useAnnouncementStore()

   return (
      <>
         {Object.entries(announcementStore.allAnnouncements).map(([announcementKey, announcement]) => (
            <Announcement
               key={announcementKey}
               type={announcement.type}
               dismissible={announcement.dismissible}
               announcementKey={announcementKey as AnnouncementEnum}>
               {announcement.content}
            </Announcement>
         ))}
      </>
   )
})
